{
    "releaseNotes": {
        "tabName": "Versiuni anterioare",
        "accordianHeading": "Versiunea me@eon V<version>",
        "accordianMyHelpHeading": "Versiunea MyHelp (me@eon) V<version>",
        "accordianMyHelpNewHeading": "Versiunea MyHelp V<version>",
        "whatsNew": "Ce e nou",
        "tipsAndTricks": "Sfaturi și trucuri",
        "faq": "Întrebări frecvente"
    },
    "ourTeam": {
        "tabName": "Echipa noastră",
        "keyMembers": "Membri importanti"
    },
    "featureRoadmap": {
        "tabName": "Funcții & Planificare"
    }
}